type Params = {
  name: string
  value: string | number
  additional?: Record<string, unknown>
}

export function logEvent({name, value, additional}: Params) {
  try {
    if (typeof value === 'string') {
      Ya.Rum.logEventString(name, value, {additional})
      return
    }

    Ya.Rum.logEventInteger(name, Math.trunc(value), {additional})
  } catch (error) {
    console.error(error)
  }
}
